(() => {
  'use strict';

  /* PN_MENTOR_UPI_V1 */

  const FUNCTION_URL =
    'https://tnlkoibetblgiovgkufs.supabase.co/functions/v1/razorpayx-sync-upi';


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:'POST',
          body
        }
      );

  }


  async function syncProvider() {

    const session =
      await window.PeerNestDB
        .getSession();


    if (
      !session?.access_token
    ) {

      throw new Error(
        'Please sign in again.'
      );

    }


    const response =
      await fetch(
        FUNCTION_URL,
        {
          method:'POST',

          headers:{
            Authorization:
              `Bearer ${session.access_token}`,

            'Content-Type':
              'application/json'
          },

          body:'{}'
        }
      );


    const data =
      await response.json()
        .catch(
          () => ({})
        );


    if (!response.ok) {

      throw new Error(
        data?.error ||
        'Could not configure UPI payout.'
      );

    }


    return data;

  }


  async function load(card) {

    try {

      const result =
        await rpc(
          'get_my_mentor_payout_profile_v1'
        );


      const input =
        card.querySelector(
          '[data-pn-upi-input]'
        );

      const status =
        card.querySelector(
          '[data-pn-upi-status]'
        );


      if (input) {

        input.value =
          result?.upi_id ||
          '';

      }


      if (status) {

        status.textContent =
          result?.configured
            ? `Ready for payouts · ${result.destination_hint || 'UPI'}`
            : (
                result?.upi_id
                  ? 'UPI saved · provider setup required'
                  : 'Add your UPI ID'
              );

        status.dataset.state =
          result?.configured
            ? 'ready'
            : 'pending';

      }

    }
    catch (_) {}

  }


  function mount() {

    if (!window.PeerNestDB) {
      return;
    }


    const view =
      document.querySelector(
        '[data-pnmd-view="earnings"]'
      );


    if (
      !view ||
      view.querySelector(
        '[data-pn-upi-card]'
      )
    ) {
      return;
    }


    const card =
      document.createElement(
        'section'
      );


    card.className =
      'pn-mentor-upi-card';

    card.setAttribute(
      'data-pn-upi-card',
      ''
    );


    card.innerHTML = `
      <div class="pn-mentor-upi-card__head">

        <div>
          <span>PAYOUT DETAILS</span>
          <h3>UPI payout account</h3>

          <p>
            Add the UPI ID where PeerNest should send your mentor earnings.
          </p>
        </div>

        <strong data-pn-upi-status>
          Loading…
        </strong>

      </div>


      <div class="pn-mentor-upi-card__form">

        <label>
          <span>UPI ID</span>

          <input
            type="text"
            autocomplete="off"
            placeholder="yourname@bank"
            data-pn-upi-input
          >
        </label>


        <button
          type="button"
          data-pn-upi-save
        >
          Save payout details
        </button>

      </div>


      <small>
        Your UPI ID is used only for mentor payouts.
      </small>
    `;


    view.appendChild(card);


    card
      .querySelector(
        '[data-pn-upi-save]'
      )
      ?.addEventListener(
        'click',
        async event => {

          const button =
            event.currentTarget;

          const input =
            card.querySelector(
              '[data-pn-upi-input]'
            );

          const status =
            card.querySelector(
              '[data-pn-upi-status]'
            );


          const upi =
            String(
              input?.value ||
              ''
            )
              .trim()
              .toLowerCase();


          if (!upi.includes('@')) {

            status.textContent =
              'Enter a valid UPI ID';

            return;

          }


          button.disabled =
            true;

          button.textContent =
            'Saving…';

          status.textContent =
            'Configuring RazorpayX…';


          try {

            await rpc(
              'set_my_mentor_upi_v1',
              {
                p_upi_id:
                  upi
              }
            );


            await syncProvider();


            status.textContent =
              'Ready for payouts';

            status.dataset.state =
              'ready';

            button.textContent =
              'Saved ✓';


            await load(card);

          }
          catch (error) {

            status.textContent =
              error?.message ||
              'Could not save payout details';

            status.dataset.state =
              'error';

            button.textContent =
              'Try again';

          }
          finally {

            button.disabled =
              false;

          }

        }
      );


    load(card);

  }


  const observer =
    new MutationObserver(
      mount
    );


  observer.observe(
    document.documentElement,
    {
      childList:true,
      subtree:true
    }
  );


  document.addEventListener(
    'DOMContentLoaded',
    mount
  );


  setTimeout(
    mount,
    500
  );

})();
